import { Fragment, useState } from "react";

import Link from "@/components/wpl/link/src";

import { Modal } from "./modal";

interface LinkModalProps {
    text: string;
    content: (height: string) => React.ReactNode;
}

export const LinkModal = ({ text, content }: LinkModalProps) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Fragment>
            <Link
                href="#"
                type="modal"
                onClick={(event) => {
                    event.preventDefault();
                    setIsOpen(true);
                }}
                text={text}
            />
            <Modal
                content={content}
                closeModal={() => setIsOpen(false)}
                isOpen={isOpen}
                isContentModal={true}
            />
        </Fragment>
    );
};
